import { Pipe, type PipeTransform } from '@angular/core'
import { type DealerDTO } from '../services/dealers.service'

@Pipe({
  name: 'dealername',
  standalone: true,
})
export class DealerNamePipe implements PipeTransform {
  transform (dealer: DealerDTO): string {
    let dealerName = ''
    dealerName += dealer.name
    dealerName +=
      dealer.subname != null && dealer.subname.trim() !== ''
        ? ', ' + dealer.subname
        : ''
    return dealerName
  }
}
